import request from "@/utils/request";
import qs from "qs";
/**
 * 用户信息
 */
export function getPetUserApi(data) {
  return request({
    url: "/user/getPetUser",
    method: "post",
    data: qs.stringify(data),
  });
}
export function getOauth2(code) {
  return request({
    url: `/auth/zf/login/user/${code}`,
    method: "get",
  });
}
